/* The open chat, remembered without a model call.
   A summary or a "say that more simply" is built from what she already
   said. That costs nothing, and it is the same thread. */

import { ZChatMsg } from './chats';

const WHOLE = /\b(summari[sz]e (this|the|our) chat|summari[sz]e (the|our) (whole )?conversation|what (have|did) we (talk|discuss)|recap (this|the) chat)\b/i;
const LAST = /\b(summari[sz]e what you (just )?said|what did you (just )?say|say that again|repeat that)\b/i;
const SIMPLE = /\b(simplif\w*|simpler|simply|plain english|shorter|too long|in short|break (that|it) down)\b/i;

function said(m: ZChatMsg): string {
  return (m.headline || m.text || '').replace(/\s+/g, ' ').trim();
}

function sentences(text: string, n: number): string {
  const parts = text.split(/(?<=[.!?])\s+/).filter(Boolean);
  return parts.slice(0, n).join(' ');
}

/** What this turn should send the model: her answer, and whether it landed. */
export function turnForModel(m: ZChatMsg): string {
  if (m.from === 'you') return m.text;
  const body = [m.headline || m.text, m.note].filter(Boolean).join(' ');
  const mark = m.rating === 'good' ? ' [owner: useful]' : m.rating === 'bad' ? ' [owner: not useful]' : '';
  return `${body}${mark}`.slice(0, 480);
}

/** A reply drawn from this chat, or null when the question needs the fleet. */
export function recallThread(question: string, messages: ZChatMsg[]): string | null {
  const q = question.trim();
  if (!q || !messages.length) return null;
  const hers = messages.filter((m) => m.from === 'zana' && said(m));
  const last = hers[hers.length - 1];
  if (WHOLE.test(q)) {
    const lines = messages.slice(-8).map((m) => (
      m.from === 'you' ? `You asked: ${m.text.replace(/\s+/g, ' ').trim()}` : `I said: ${sentences(said(m), 2)}`
    )).filter((l) => !/I said:\s*$/.test(l));
    if (!lines.length) return null;
    return `Here is this chat, in short.\n${lines.join('\n')}`;
  }
  if (!last) return null;
  if (LAST.test(q)) return sentences(said(last), 3);
  if (SIMPLE.test(q)) return sentences(said(last), 2);
  return null;
}
